import React from "react";

const Policy = ({ allowCancel, allowUpdate, producerName }) => (
  <div className="r_cancellationPolicy">
    <div className="r_policyContainer">
      <div className={allowCancel ? "r_green" : "r_red"} style={{fontSize: 14}}>
        {allowCancel
          ? cancellationpolicy_resources.CancellationAllowedNoIcon
          : cancellationpolicy_resources.CancellationsNotAllowedNoIcon}
      </div>
      <div className={allowUpdate ? "r_green" : "r_red"} style={{fontSize: 14}}>
        {allowUpdate
          ? cancellationpolicy_resources.ReissueAllowedNoIcon
          : cancellationpolicy_resources.ReissueNotAllowedNoIcon}
      </div>
    </div>
    <div>
      {producerName && (
        <span style={{fontSize: 12}}>
          {cancellationpolicy_resources.ContactOrganizerInfo}
          <strong> {producerName}</strong>.
        </span>
      )}{" "}
      <span style={{fontSize: 12}}>{cancellationpolicy_resources.LinkProducerForPolicyBody}</span>
    </div>
  </div>
);

export default Policy;
